export enum ANT_DESIGN_TEXT_SIZE_ENUM {
  CAPTION = "caption",
  SM = "sm",
  MD = "md",
  LG = "lg",
  XL = "xl"
}
